import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kids-eat-free-mondays',
  templateUrl: './kids-eat-free-mondays.component.html',
  styleUrls: ['./kids-eat-free-mondays.component.scss']
})
export class KidsEatFreeMondaysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/kids-eat-free-mondays/kids-eat-free-mondays.component.ts